import { render, staticRenderFns } from "./Main.vue?vue&type=template&id=1a712293&scoped=true&"
import script from "./Main.vue?vue&type=script&lang=js&"
export * from "./Main.vue?vue&type=script&lang=js&"
import style0 from "./Main.scss?vue&type=style&index=0&id=1a712293&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../home/gitlab-runner/.nvm/versions/node/v12.14.1/lib/node_modules/@briskly/vue-cli/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a712293",
  null
  
)

export default component.exports